import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Bridge, BridgeService } from './bridge.service';

export interface BridgeDialogData {
    bridges: Bridge[];
    activeId: string;
}

@Component({
    selector: 'app-bridge-dialog',
    templateUrl: './bridge-dialog.component.html',
    styleUrls: ['./bridge-dialog.component.scss'],
})
export class BridgeDialogComponent {
    public draft: Partial<Bridge> = { name: '', keycloakRealm: '', apiPath: '' };

    constructor(
        private dialogRef: MatDialogRef<BridgeDialogComponent>,
        private bridgeService: BridgeService,
        @Inject(MAT_DIALOG_DATA) public data: BridgeDialogData,
    ) {}

    get bridges(): Bridge[] {
        return this.bridgeService.bridges;
    }

    get canAdd(): boolean {
        return Boolean(this.draft.keycloakRealm?.trim() && this.draft.apiPath?.trim());
    }

    // Guess the matching API host, the way the hosted deployments are laid out.
    realmChanged(): void {
        const realm = (this.draft.keycloakRealm || '').trim();
        if (realm && !this.draft.apiPath) {
            this.draft.apiPath = `https://api.${realm}.iotbridge.se/PYST/v1.0`;
        }
    }

    add(): void {
        if (!this.canAdd) {
            return;
        }
        this.bridgeService.saveBridge(this.draft);
        this.draft = { name: '', keycloakRealm: '', apiPath: '' };
    }

    remove(bridge: Bridge): void {
        this.bridgeService.removeBridge(bridge.id);
    }

    // Switching realms rebuilds the Keycloak client, so this reloads the page.
    activate(bridge: Bridge): void {
        if (bridge.id === this.data.activeId) {
            this.dialogRef.close();
            return;
        }
        this.bridgeService.switchAndReload(bridge.id);
    }

    close(): void {
        this.dialogRef.close();
    }
}
